import React from 'react';
import { CreateCollectionForm } from './CreateCollectionForm';
import { ModalArea } from './ModalButtonArea.js';

export default function CreateCollectionPopup({
  onSuccess,
  className,
  parentClassName,
  showNew = false,
  setShowNew = () => {},
}) {
  let title = 'Create collection';
  let subtitle = 'Please add a name and description for the collection';

  const onCollectionCreateSuccess = (newCollection) => {
    console.log('newCollection: ', newCollection);
    onSuccess?.(newCollection || '');
    setShowNew(false);
  };

  function onClose() {
    setShowNew(false);
  }

  return (
    <ModalArea
      showModal={showNew}
      setShowModal={onClose}
      className={className}
      parentClassName={parentClassName}
      title={title}
      subtitle={subtitle}
      size="md"
      modalClassName="add-to-collection-dialog"
      centered={true}
      body={
        <CreateCollectionForm
          onCancel={() => setShowNew(false)}
          onSuccess={onCollectionCreateSuccess}
        />
      }
    />
  );
}
